module.exports = __webpack_public_path__ + "img/a2-s62.4eeed3fc.jpg";